export default __webpack_public_path__ + "static/media/C_04_01_map.5e70b3e1.jpg";